module.exports = __webpack_public_path__ + "static/img/traning2.1f155855.png";